import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'personUrl' })
export class PersonUrlPipe implements PipeTransform {
  transform(value: { id: number; firstName?: string; lastName?: string }) {
    if (value) {
      return ['/scholar', value.id, value.firstName + '-' + value.lastName];
    } else {
      return [];
    }
  }
}
